import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import './assets/css/style.less'
Vue.config.productionTip = false
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview)
import layer from 'vue-layer'
import 'vue-layer/lib/vue-layer.css'
Vue.prototype.$layer = layer(Vue)
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
